export default "__VITE_ASSET__D5Je_zYL__"